import React from 'react';

const ComplementaryOptions = ({ tarifsComplementaires, tarifsSup, toggleTarifSup }) => {
  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      <h3 className="text-lg font-medium text-gray-900 mb-3">Options complémentaires</h3>
      <div className="space-y-3">
        {tarifsComplementaires.map((tarif) => (
          <div key={tarif.id} className="flex items-center justify-between p-3 bg-white rounded-lg border border-gray-200">
            <div className="flex items-center space-x-3">
              <input
                type="checkbox"
                id={`tarif-${tarif.id}`}
                checked={tarifsSup.some(t => t.id === tarif.id)}
                onChange={() => toggleTarifSup(tarif)}
                className="h-4 w-4 text-[#202654] focus:ring-[#202654] rounded"
              />
              <label htmlFor={`tarif-${tarif.id}`} className="text-sm font-medium text-gray-700">
                {tarif.libelle}
              </label>
            </div>
            <span className="text-sm font-medium text-blue-600">
              {tarif.prix.toLocaleString()} FCFA
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComplementaryOptions;
